import environment from "../../environment";
import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Staff',
  addTitle: ' Staff',
  role: environment.subAdminRole,
  url: 'user',
  route: 'staff',
  ...Routes.Staff

};

export default shared;
